import { createReducer, on, Action } from '@ngrx/store';
import { EntityState, createEntityAdapter, EntityAdapter } from '@ngrx/entity';
import * as CostGenericDocActions from '../_actions/costGenericDoc';
import { CostGenericDoc } from '../_models/financials';

export interface CostGenericDocState extends EntityState<CostGenericDoc> {
  loading: boolean;
  error: any;
}

export const adapter: EntityAdapter<CostGenericDoc> = createEntityAdapter<CostGenericDoc>();

const initialState: CostGenericDocState = adapter.getInitialState({
  loading: false,
  error: null,
});

const costGenericDocReducer = createReducer(
  initialState,

  on(CostGenericDocActions.loadCostGenericDocs, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),

  on(CostGenericDocActions.loadCostGenericDocsSuccess, (state, { costGenericDocs }) =>
    adapter.setAll(costGenericDocs, { ...state, loading: false })
  ),

  on(CostGenericDocActions.loadCostGenericDocsFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),

  on(CostGenericDocActions.addCostGenericDocSuccess, (state, { costGenericDoc }) =>
    adapter.addOne(costGenericDoc, state)
  ),

  on(CostGenericDocActions.updateCostGenericDocSuccess, (state, { costGenericDoc }) =>
    adapter.upsertOne(costGenericDoc, state)
  ),

  on(CostGenericDocActions.deleteCostGenericDocSuccess, (state, { id }) =>
    adapter.removeOne(id, state)
  ),

  on(
    CostGenericDocActions.addCostGenericDocFailure,
    CostGenericDocActions.updateCostGenericDocFailure,
    CostGenericDocActions.deleteCostGenericDocFailure,
    (state, { error }) => ({
      ...state,
      error,
    })
  )
);

export function reducer(state: CostGenericDocState | undefined, action: Action) {
  return costGenericDocReducer(state, action);
}

export const { selectAll, selectEntities, selectTotal } = adapter.getSelectors();
